module.exports = __webpack_public_path__ + "img/icons B_33.fd571df7.png";